import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "titleCase",
    standalone: true
})
export class TitleCasePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return "";

    const preserveWords = new Set([
      "II",
      "III",
      "IV",
      "VI",
      "AI",
      "HTML",
      "CSS",
      "JS",
      "USA",
      "UK",
      "US",
    ]);

    return value
      .split(" ")
      .map((word) => {
        const cleanWord = word.replaceAll(/[^a-zA-Z0-9]/g, "").toUpperCase();
        if (preserveWords.has(cleanWord)) {
          return word.toUpperCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(" ");
  }
}
